import { render, staticRenderFns } from "./process.vue?vue&type=template&id=9c81a15a&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c81a15a",
  null
  
)

export default component.exports